(function () {
    const developmentConfig = _.merge(
        {},
        {
            debug: true,
            UI_URI: 'http://localhost:8080',
            PLAYER_URI: 'http://localhost:4000',
            APPS_URI: 'http://localhost:5000',
            CUSTOM_APPS_URI: 'http://localhost:5555',
            API_URI: 'http://localhost:3000',
            SLS_URI: 'http://localhost:7000',
            SERVICES_URI: 'http://localhost:7001',
            WS_URI: 'ws://localhost:6020',
            features: {
                gateway: true,
                screenshots: true,
                files: true,
                playlists: true,
                schedules: true,
                sampleAppPreview: true,
            },
        },
        window.__ROCKET_CONFIG__ || {}
    );

    angular
        .module('rocket.components', [
            'rocket.api',
            'environment',
            'ui.router',
            'pascalprecht.translate',
            'ngScrollbars',
            'LocalStorageModule',
            'ngMaterial',
            'formly',
            'formlyMaterial',
            'fuse.msNavigation'
        ])
        .config((LoopBackResourceProvider, envServiceProvider, $compileProvider) => {
            envServiceProvider.config({
                domains: {
                    // UNCOMMENT TO RUN LOCALLY AND POINT TO STAGE
                    // stage: ['localhost'],

                    // COMMENT OUT FOLLOWING TO RUN LOCALLY AND POINT TO STAGE
                    development: ['localhost'],
                    stage: ['manager.stage.signagerocket.com'],

                    production: ['manager.signagerocket.com'],
                },
                vars: {
                    development: developmentConfig,
                    stage: {
                        debug: true,
                        UI_URI: 'https://manager.stage.signagerocket.com',
                        PLAYER_URI: 'https://player.stage.signagerocket.com',
                        APPS_URI: 'https://apps.stage.signagerocket.com',
                        CUSTOM_APPS_URI: 'https://app.stage.signagerocket.com',
                        API_URI: 'https://rocket-api-stage.herokuapp.com',
                        SLS_URI: 'https://sls.stage.signagerocket.com',
                        SERVICES_URI: 'https://services.stage.signagerocket.com',
                        WS_URI: 'wss://rocket-ws-stage.herokuapp.com',
                        features: {
                            gateway: true,
                            screenshots: true,
                            files: true,
                            playlists: true,
                            schedules: true,
                            sampleAppPreview: true,
                        },
                    },
                    production: {
                        debug: true,
                        UI_URI: 'https://manager.signagerocket.com',
                        PLAYER_URI: 'https://player.signagerocket.com',
                        APPS_URI: 'https://apps.signagerocket.com',
                        CUSTOM_APPS_URI: 'https://app.signagerocket.com',
                        API_URI: 'https://rocket-api-prod.herokuapp.com',
                        SLS_URI: 'https://sls.signagerocket.com',
                        SERVICES_URI: 'https://services.signagerocket.com',
                        WS_URI: 'wss://rocket-ws.herokuapp.com',
                        features: {
                            gateway: false,
                            screenshots: true,
                            files: true,
                            playlists: true,
                            schedules: false,
                            sampleAppPreview: false,
                        },
                    },
                },
            });
            envServiceProvider.check();

            // set debug info
            const DEBUG = envServiceProvider.read('debug');
            $compileProvider.debugInfoEnabled(DEBUG);
            $compileProvider.commentDirectivesEnabled(false);
            $compileProvider.cssClassDirectivesEnabled(false);

            // set URI
            const API_URI = envServiceProvider.read('API_URI');
            const ENV = envServiceProvider.get();

            LoopBackResourceProvider.setAuthHeader('Authorization');
            LoopBackResourceProvider.setUrlBase(API_URI);
        })

        .config(($mdAriaProvider, $urlRouterProvider, $locationProvider, $translateProvider, ScrollBarsProvider) => {
            $urlRouterProvider.otherwise('/');
            $locationProvider.html5Mode(true);

            // angular-translate configuration
            $translateProvider.useLoaderCache('$templateCache');
            $translateProvider.useLoader('$translatePartialLoader', {
                urlTemplate: '{part}/i18n/{lang}.json',
            });
            $translateProvider.preferredLanguage('en');
            $translateProvider.useSanitizeValueStrategy('sanitize');

            $mdAriaProvider.disableWarnings();
            ScrollBarsProvider.defaults = {
                autoHideScrollbar: false,
                theme: 'light-thin',
                advanced: {
                    updateOnContentResize: true,
                },
                scrollInertia: 0,
                axis: 'y',
            };
        })

        .config((envServiceProvider, localStorageServiceProvider) => {
            const env = _.get(envServiceProvider, 'environment', 'rocket');
            const prefix = `rocket_${env}`;
            localStorageServiceProvider.setPrefix(prefix);
        })

        //  UI ROUTER TRACE
        // .run($trace => $trace.enable())

        .constant('_', window._)

        .run((LoopBackAuth, $state, $rootScope) => {
            $rootScope.$on('$stateChangeError', function (event, toState, toParams, fromState, fromParams, error) {
                const { detail: { status, redirectTo } = {} } = error;

                if (status === 401) {
                    LoopBackAuth.clearUser();
                    LoopBackAuth.clearStorage();
                    return $state.go('login');
                }

                if (redirectTo) return $state.go(redirectTo);
                return $state.go('root.home');
            });
        })

        .factory('authInterceptor', function (LoopBackAuth) {
            return {
                request: function (config) {
                    // skip the header for the S3 requests
                    const method = _.get(config, 'method');
                    const url = _.get(config, 'url');
                    if (method === 'PUT' && url.includes('s3.eu-west-2.amazonaws.com')) {
                        return config;
                    }

                    if (!config.headers.Authorization && LoopBackAuth.accessTokenId) {
                        config.headers.Authorization = LoopBackAuth.accessTokenId;
                    }
                    return config;
                },
            };
        })

        .factory('subAccountInterceptor', (envService, Store) => {
            const API_URL = envService.read('API_URI');

            const URLS_TO_USE_SUB_ACCOUNT_ON = [
                `${API_URL}/`,
                `${API_URL}/apps`,
                `${API_URL}/displays`,
                `${API_URL}/users`,
                `${API_URL}/playlists`,
                `${API_URL}/groups`,
                `${API_URL}/schedules`,
            ];
            return {
                request: function (config) {
                    const url = _.get(config, 'url');
                    const method = _.get(config, 'method');

                    // if does not match the URL we want to cover, bail
                    if (!url.includes(API_URL)) return config;
                    if (!URLS_TO_USE_SUB_ACCOUNT_ON.includes(url)) return config;

                    // read the sub account and make sure it's not 0
                    // 0 is angular wtf when the value is null - ie. not selected
                    const subAccountId = Store.getCurrentSubAccountId();

                    switch (method) {
                        case 'GET': {
                            // if subAccountId is null - means we are looking from main account
                            // we might need to move everything to the sub accounts
                            // and create one as a default
                            if (subAccountId || _.isNull(subAccountId)) {
                                _.set(config, 'params.filter.where.subAccountId', subAccountId);
                            } else {
                                _.unset(config, 'params.filter.where.subAccountId');
                            }
                            break;
                        }

                        case 'DELETE': {
                            if (subAccountId) {
                                _.set(config, 'params.filter.where.subAccountId', subAccountId);
                            } else {
                                _.unset(config, 'params.filter.where.subAccountId');
                            }
                            break;
                        }

                        case 'POST': {
                            if (subAccountId) {
                                _.set(config, 'data.subAccountId', subAccountId);
                            } else {
                                _.unset(config, 'data.subAccountId');
                            }
                            break;
                        }

                        default: {
                            console.log('no method match');
                        }
                    }
                    return config;
                },
            };
        })

        .config(($httpProvider) => {
            $httpProvider.interceptors.push('authInterceptor');
            $httpProvider.interceptors.push('subAccountInterceptor');
        })

        .controller('MainController', ($scope, $rootScope) => {
            // Remove the splash screen
            $scope.$on('$viewContentAnimationEnded', function (event) {
                if (event.targetScope.$id === $scope.$id) {
                    $rootScope.$broadcast('msSplashScreen::remove');
                }
            });
        });
})();
